import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, pwd);
      toast.success("Signed in");
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2" data-testid="login-page">
      <div className="hidden md:flex flex-col justify-between p-10 bg-[#0F172A] text-white relative overflow-hidden">
        <div className="relative z-10 flex items-center">
          <img src="/tn-logo.png" alt="thinkneural.ai" className="h-14 w-auto" data-testid="login-logo"/>
        </div>
        <div className="relative z-10">
          <div className="label-micro text-slate-400">Internal · v1.0</div>
          <h1 className="font-display text-4xl lg:text-5xl font-black leading-tight mt-3">
            Let's close today.
          </h1>
          <p className="text-slate-300 mt-4 max-w-md text-sm leading-relaxed">
            Your pipeline is right where you left it. Sign in and go win.
          </p>
        </div>
        <div className="relative z-10 text-xs text-slate-500">ThinkNeural AI · Sales Suite</div>
        <div className="absolute inset-0 opacity-30 bg-cover" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&w=1400&q=70)'}} />
      </div>

      <div className="flex items-center justify-center p-8 md:p-16 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="label-micro mb-3">Sign in</div>
          <h2 className="font-display text-3xl font-bold mb-8">Welcome back.</h2>

          <label className="label-micro" htmlFor="email">Email</label>
          <input
            id="email"
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full border border-slate-300 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          />

          <label className="label-micro mt-5 block" htmlFor="pwd">Password</label>
          <input
            id="pwd"
            data-testid="login-password"
            type="password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            className="mt-1 w-full border border-slate-300 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            required
          />

          <button
            data-testid="login-submit"
            disabled={busy}
            className="mt-6 w-full flex items-center justify-center gap-2 bg-slate-900 hover:bg-blue-700 text-white text-sm font-semibold rounded-sm py-3 transition-colors duration-200 disabled:opacity-60"
          >
            {busy ? "Signing in…" : (<>Continue <ArrowRight size={16} /></>)}
          </button>
        </form>
      </div>
    </div>
  );
}
